export default {
    data() {
        return {
            pageNumber: 0,
        }
    },
    computed: {
        pageCount() {
            const length = this.items.length;
            const size = this.itemsPerBlock;
            return Math.ceil(length / size);
        },
        itemsToShow() {
            const start = this.pageNumber * this.itemsPerBlock;
            const end = start + this.itemsPerBlock;
            return this.items.slice(start, end);
        },
        disableDown() {
            return this.pageNumber === this.pageCount - 1;
        },
        disableUp() {
            return this.pageNumber === 0
        },
    },
    methods: {
        nextPage() {
            this.pageNumber += 1;
        },
        prevPage() {
            this.pageNumber -= 1;
        },
    },
    watch: {
        items: {
            handler() {
                this.pageNumber = 0
            },
            immediate: true,
        },
    },
}
